module.exports = __webpack_public_path__ + "img/masthead-frontier.4e630a3d.jpg";